<fieldset [formGroup]="group" class="in-two-columns">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>
  <!-- type -->

  <mat-form-field>
    <app-easy-select
      formControlName="type"
      [label]="TITLE + 'GIN_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.GIN_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="ginTypes | toSelectOption: 'PRODUCTS.GIN_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- style -->

  <mat-form-field>
    <app-easy-select
      formControlName="style"
      [label]="TITLE + 'GIN_STYLE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.GIN_STYLE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="ginStyles | toSelectOption: 'PRODUCTS.GIN_STYLE.'"
    >
    </app-easy-select>
  </mat-form-field>
</fieldset>
